import React from 'react';
import './Styles.scss';
import Progress from '../../../App/Shared/Components/Progress/Progress';
import PropTypes from 'prop-types';

const LoadingOverlay = props => (
    <div className={'loadingoverlay ' + (props.show ? 'show' : 'hide')} onClick={e => e.stopPropagation()}>
        <Progress loading={props.show} />
    </div>
);

LoadingOverlay.propTypes = {
    show: PropTypes.bool,
};

export default LoadingOverlay;
